import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { MarketplacePartnerRegisterPageFormInputField } from '../MarketplacePartnerRegisterPageFormInputField'

export const MarketplacePartnerRegisterPageFormBrandsProductsCount: FC = () => {
  return (
    <div className="flex flex-col gap-4">
      <div className="text-l">
        <FormattedMessage id="marketplacePartnerRegisterPage.brands.productsCount.input.description" />
      </div>
      <MarketplacePartnerRegisterPageFormInputField
        fieldName="productsCount"
        label={
          <FormattedMessage id="marketplacePartnerRegisterPage.brands.productsCount.input.label" />
        }
        required
        type="number"
      />
    </div>
  )
}
